$(document).on("vltk_cachep_float_right rendered", {}, function(event, uniqueId){
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $this.find(".aside__item--toggle").on("click", function(e){
        e.preventDefault();
        $this.find(".aside").toggleClass("active");
    });

});